import React, { useState } from 'react';

import { Slider, Typography } from '@mui/material';



function FilterRange({priceMinMax, onChange}) {
  

  return (
    <div>
      <Typography style={{color:'grey', textAlign:'center'}} id="price-range-slider" gutterBottom>
        Price
      </Typography>
      <Slider
        value={priceMinMax}
        onChange={onChange}
        valueLabelDisplay="auto"
        aria-labelledby="price-range-slider" 
        min={0}
        max={3000}
      />
      <Typography style={{color:'grey', textAlign:'center'}}>
        {priceMinMax[0] +'$'} - {priceMinMax[1] +'$'}
      </Typography>
    </div>
  );
  
}

export default FilterRange;

